import { lazy } from "react";
import { Route } from "react-router-dom";
import { ClientLayout } from "../components/layout/AppLayout";

/**
 * Groupe de routes CLIENT (12) — SITE_SPEC §3.3.
 * Montées sous `path="panel"` avec <ClientLayout> qui applique la garde d'authentification
 * (redirige vers /connexion si non connecté). À insérer sous <AppLayout>.
 */

const Dashboard = lazy(() => import("../pages/client/Dashboard"));
const BattlePass = lazy(() => import("../pages/client/BattlePass"));
const Quetes = lazy(() => import("../pages/client/Quetes"));
const Profil = lazy(() => import("../pages/client/Profil"));
const Inventaire = lazy(() => import("../pages/client/Inventaire"));
const Statistiques = lazy(() => import("../pages/client/Statistiques"));
const Historique = lazy(() => import("../pages/client/Historique"));
const Economie = lazy(() => import("../pages/client/Economie"));
const Claims = lazy(() => import("../pages/client/Claims"));
const Homes = lazy(() => import("../pages/client/Homes"));
const Guilde = lazy(() => import("../pages/client/Guilde"));
const Hdv = lazy(() => import("../pages/client/Hdv"));
const Parametres = lazy(() => import("../pages/client/Parametres"));
const Liaison = lazy(() => import("../pages/client/Liaison"));

export const clientRoutes = (
  <Route path="panel" element={<ClientLayout />}>
    <Route index element={<Dashboard />} />
    <Route path="battlepass" element={<BattlePass />} />
    <Route path="quetes" element={<Quetes />} />
    <Route path="profil" element={<Profil />} />
    <Route path="inventaire" element={<Inventaire />} />
    <Route path="statistiques" element={<Statistiques />} />
    <Route path="historique" element={<Historique />} />
    <Route path="economie" element={<Economie />} />
    <Route path="claims" element={<Claims />} />
    <Route path="homes" element={<Homes />} />
    <Route path="guilde" element={<Guilde />} />
    <Route path="hdv" element={<Hdv />} />
    <Route path="parametres" element={<Parametres />} />
    <Route path="liaison" element={<Liaison />} />
  </Route>
);
